import React from 'react'

function FeaturesTwo({ content }) {
  return (
    <section id={'featuresTwo'} className="FeaturesTwo">
      {content.main.map((content, _idx) => (
        <FeaturesTwoItem key={`FeaturesTwoItem-${_idx}`} content={content} />
      ))}
    </section>
  )
}

function FeaturesTwoItem({ content }) {
  return (
    <div className={'FeaturesTwo-item'}>
      {content.img}
      <h1 className="inter">{content.h}</h1>
      <p>{content.p}</p>
    </div>
  )
}

export default FeaturesTwo



// WEBPACK FOOTER //
// ./src/Views/Home/FeaturesTwo.js